import type { Event } from '@bugsnag/js'

const DISCARDED_ERRORS = [/ResizeObserver loop/i, /Invalid call to runtime\.sendMessage/i]

export const isDiscardedBugsnagEvent = (event: Event) => {
  const message = event.errors?.[0]?.errorMessage ?? ''
  return DISCARDED_ERRORS.some(pattern => pattern.test(message))
}
